import { useAuthStore } from '@/store/authStore';
import * as permissions from '@/utils/permissions';

export function usePermissions() {
  const staffRole = useAuthStore((s) => s.staffRole);

  return {
    role: staffRole,
    roleLabel: permissions.getRoleLabel(staffRole),
    roleBadgeColor: permissions.getRoleBadgeColor(staffRole),
    isOwnerOrSolo: permissions.isOwnerOrSolo(staffRole),
    isManagerOrAbove: permissions.isManagerOrAbove(staffRole),
    isTechnician: permissions.isTechnician(staffRole),
    canViewFinancials: permissions.canViewFinancials(staffRole),
    canManageStaff: permissions.canManageStaff(staffRole),
    canSetStaffPassword: permissions.canSetStaffPassword(staffRole),
    canGenerateTechnicianPin: permissions.canGenerateTechnicianPin(staffRole),
    canViewBilling: permissions.canViewBilling(staffRole),
    canManageSettings: permissions.canManageSettings(staffRole),
    canManageIntake: permissions.canManageIntake(staffRole),
    canDeleteCustomer: permissions.canDeleteCustomer(staffRole),
    canDeleteInventory: permissions.canDeleteInventory(staffRole),
  };
}
